<div class="note-container" *ngIf="context">
  <div class="note-header">
    <img src="/assets/images/icons/info-icon.svg" alt="" />
    <p class="note-title">Attention:</p>
  </div>
  <p class="note-text">{{ context }}</p>
</div>
